import { Button } from 'shared';
import styled from 'theme';

export const SubmitButton = styled(Button)`
  margin-top: 1rem;
`;

export const LoginLink = styled.span`
  color: ${props => props.theme.variables.colors.red};
  font-weight: ${props => props.theme.variables.fonts.weight.light};
  display: block;
  text-align: right;
  width: 100%;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.variables.colors.darkRed};
  }
`;
